import axios from "@axios";

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchKarmaPrograms(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/karma-programs", { params: queryParams })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
        fetchKarmaProgramStatus() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/list/karma-programs-status")
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
        fetchKarmaProgram(ctx, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`karma-programs/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        addKarmaProgram(ctx, userData) {
            return new Promise((resolve, reject) => {
                axios
                    .post("karma-programs", userData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status === 422) {
                            if (
                                typeof error.response.data.errors !==
                                "undefined"
                            ) {
                                const keys = Object.keys(
                                    error.response.data.errors
                                );
                                const values = Object.values(
                                    error.response.data.errors
                                );
                                for (let i = 0; i <= keys.length; i += 1) {
                                    if (
                                        error.response.data.errors.hasOwnProperty.call(
                                            values,
                                            i
                                        )
                                    ) {
                                        reject(new Error(values[0][0]));
                                    }
                                }
                            }
                        } else {
                            reject(error);
                        }
                    });
            });
        },
        updateKarmaProgram(ctx, karma_program) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(`karma-programs/${karma_program.id}`, karma_program.data, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            if (
                                typeof error.response.data.errors !==
                                "undefined"
                            ) {
                                const keys = Object.keys(
                                    error.response.data.errors
                                );
                                const values = Object.values(
                                    error.response.data.errors
                                );
                                for (let i = 0; i <= keys.length; i += 1) {
                                    if (
                                        error.response.data.errors.hasOwnProperty.call(
                                            values,
                                            i
                                        )
                                    ) {
                                        reject(new Error(values[0][0]));
                                    }
                                }
                            }
                        } else {
                            reject(error);
                        }
                    });
            });
        },
        removeKarmaProgram(ctx, userId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`karma-programs/${userId}`)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        removeMultipleKarmaPrograms(ctx, ids) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/karma-programs/destroy/`, { ids: ids })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        getCustomFields() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/karma-programs/create")
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
    }
};
